import React from 'react';
import styled from 'styled-components';
import * as Ant from 'antd';

// width: 952;
// padding-bottom: 48.763%;

// 建議使用 ： 464 / 952

export default function CarouselSection({className, items}) {
  const [carouselIdx, setCarouselIdx] = React.useState(0);
  const carouselRef = React.useRef();
  return (
    <Wrapper className={className}>
      <Ant.Carousel
        dots={false}
        draggable={true}
        ref={carouselRef}
        afterChange={(idx) => {
          setCarouselIdx(idx);
        }}>
        {items.map((it, idx) => {
          return (
            <div key={idx}>
              <div className="revtel-carousel-item">
                {it.image && <img src={it.image} alt="carousel-item" />}
              </div>
            </div>
          );
        })}
      </Ant.Carousel>

      <div className="revtel-carousel-dots">
        {items.map((_, idx) => {
          const selected = idx === carouselIdx;
          return (
            <div
              key={idx}
              style={{backgroundColor: selected ? 'white' : '#ccc'}}
              onClick={() => {
                if (carouselRef.current) {
                  carouselRef.current.goTo(idx);
                }
              }}
            />
          );
        })}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  border-radius: 6px;
  overflow: hidden;

  .revtel-carousel-item {
    margin: 0;
    width: 100%;
    padding-bottom: 48.763%;
    height: 0;
    overflow: hidden;
    background: #ccc;
    position: relative;

    & > img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .revtel-carousel-dots {
    position: relative;
    margin-top: -30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;

    & > * {
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: pink;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
    }
  }
`;
